import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import { fetchFlyoutCategories } from 'core/actions/ocapi';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import SectionTitle from 'core/modules/SectionTitle/SectionTitle';
import List from 'core/modules/Partials/List/List';
import MerchantTileListItem from 'core/modules/MerchantTileList/components/MerchantTileListItem/MerchantTileListItem';

import { selectSiteUrl } from 'core/selectors/app';
import {
  selectFlyoutCategoriesConfig,
  selectFlyoutCategoriesIsLoading,
  selectFlyoutCategoriesIsLoaded,
} from 'core/modules/FlyoutCategories/selectors';
import { triggerRelatedCategoryFeaturedStoresAreViewed } from './actions';

import { makeSelectRelatedCategoryFeaturedStoresData } from './selectors';

import './RelatedCategoryFeaturedStores.scss';

export function RelatedCategoryFeaturedStores({ categoriesLoadedCallback, merchant }) {
  const dispatch = useDispatch();

  const selectRelatedCategoryFeaturedStoresData = makeSelectRelatedCategoryFeaturedStoresData();
  const categoriesDataToDisplay = useSelector(state => selectRelatedCategoryFeaturedStoresData(state, merchant));
  const siteUrl = useSelector(selectSiteUrl);
  const flyoutCategoriesConfig = useSelector(selectFlyoutCategoriesConfig);
  const isFlyoutCategoriesLoading = useSelector(selectFlyoutCategoriesIsLoading);
  const isFlyoutCategoriesLoaded = useSelector(selectFlyoutCategoriesIsLoaded);

  const { api: { params, options } } = flyoutCategoriesConfig;

  useEffect(() => {
    if (!isFlyoutCategoriesLoaded && !isFlyoutCategoriesLoading) {
      dispatch(fetchFlyoutCategories(params, options));
    }
  }, []);

  useEffect(() => {
    if (isFlyoutCategoriesLoaded) {
      categoriesLoadedCallback(categoriesDataToDisplay.length > 0);
      const { name: suspendedMerchantName } = merchant;

      categoriesDataToDisplay && categoriesDataToDisplay.forEach((category) => {
        dispatch(triggerRelatedCategoryFeaturedStoresAreViewed(category, suspendedMerchantName));
      });
    }
  }, [isFlyoutCategoriesLoaded]);

  if (isEmpty(categoriesDataToDisplay)) {
    return (null);
  }

  return (
    <div className="mn_relatedCategoryFeaturedStores" data-test="related-category-featured-stores">
      {categoriesDataToDisplay.map(categoryData => (
        <div key={categoryData.id} className="mn_categoryUnit" data-section-title={categoryData.name}>
          <SectionTitle
            title={categoryData.name}
            viewAllLinkUrl={`${siteUrl}/${categoryData.searchFriendlyName}/bc_${categoryData.id}___.htm`}
          />
          <List shouldUseCarousel>
            {categoryData.merchants.map(merchant => (
              <MerchantTileListItem
                key={merchant.id}
                merchant={merchant}
                label="Extra"
              />
            ))}
          </List>
        </div>
      ))}
    </div>
  );
}

export default (props) =>
  <ComponentErrorBoundary><RelatedCategoryFeaturedStores {...props} /></ComponentErrorBoundary>;
